exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\r\n  Stylesheet for the event recommendations page\r\n  @author Eduardo Parducci, Andrea Villeda\r\n*/\n.no-link[data-v-1143b597] {\r\n    text-decoration: none !important;\n}", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/company/profile/events/events.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;IACI,iCAAiC;CAClC","file":"events.css","sourcesContent":["/*\r\n  Stylesheet for the event recommendations page\r\n  @author Eduardo Parducci, Andrea Villeda\r\n*/\r\n\r\n.no-link {\r\n    text-decoration: none !important;\r\n  }"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1143b597","scoped":true,"hasInlineConfig":false}!./src/components/company/profile/events/events.css
// module id = V9Ta
// module chunks = 1